import {ChangeDetectionStrategy, Component} from "@angular/core";
import {
  LotteriesDialogContentComponent,
  LotteryDialogListItemDirective
} from "../lotteries-dialog-content/lotteries-dialog-content.component";
import {
  OpenLotteryListItemComponent
} from "../../../../pages/apartments-tab/components/open-lottery-list-item/open-lottery-list-item.component";
import {NotificationPage} from "../../multi-page-notification/multi-page-notification.component";

@Component({
  selector: 'homey-auto-apply-submitted-lotteries-dialog-content',
  imports: [
    LotteriesDialogContentComponent,
    LotteryDialogListItemDirective,
    OpenLotteryListItemComponent,
  ],
  templateUrl: './auto-apply-start-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutoApplyStartContentComponent extends NotificationPage<{
  readonly lotteries: string[];
}> {
}
